import {ThreeBuiltInEquipment} from '../ThreeBuiltInEquipment';
import {Box3, Vector3} from 'three';
import {
    ISaveBuiltInEquipmentData
} from "../../../../../../../common-code/interfaces/saveData/ISaveBuiltInEquipmentData";
import {TSizes} from "../../../../../../../common-code/types/geometry/TSizes";

export class ThreeOvenEquipment extends ThreeBuiltInEquipment {

    protected initSaveData(options: ISaveBuiltInEquipmentData): ISaveBuiltInEquipmentData {
        if (this.unit) {
            const corpusSizes: TSizes = this.unit.getCorpusSizes();
            options.sizes.length = corpusSizes.length - 4;
        }
        return super.initSaveData(options) as ISaveBuiltInEquipmentData;
    }

    protected initPosition(): Vector3 {
        let cover: Box3;
        let initPosition: Vector3;
        let corpusPosition: Vector3;
        let unitOvenPosition: Vector3 | undefined;

        cover = this.unit.getCorpusCoverBox();
        corpusPosition = this.unit.getCorpusPosition();
        initPosition = new Vector3();
        unitOvenPosition = this.unit.getOvenPosition();
        if (unitOvenPosition) {
            unitOvenPosition.z = corpusPosition.z + cover.max.z;
            return unitOvenPosition;
        }
        initPosition.y = cover.max.y - this.getHeight()/2;
        initPosition.z = corpusPosition.z + cover.max.z;

        return initPosition;
    }
}